import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TocIcon from '@mui/icons-material/Toc';
import { EventsModel } from 'model/screensModels/EventsModel';
import { useEffect, useMemo, useState } from 'react';
import { EventsService } from 'services/menu/eventsService/EventsService';
import { msgTypes } from 'constants/msgTypes';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import { Form, Formik } from 'formik';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import FormikControl from 'components/wrapperComponents/FormikControl';
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from '@mui/material/Tooltip';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CollectionsIcon from '@mui/icons-material/Collections';
import DialogBox from 'screens/sharedScreens/dialogbox/DialogBox';
import EventGallery from './EventGallery';
import { conformationAlert } from 'services/shared/alert';
import DeleteIcon from '@mui/icons-material/Delete';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function indexProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function EventList({ setFlag, updateRecord }) {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  

  //to get update record value
  const getUpdateRecordValue = (eventsModel: EventsModel) => {
    updateRecord(eventsModel);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%' }} className="container-subheaders">

        <Box>
          <Tabs className='tab-list' value={value} onChange={handleChange} aria-label="basic tabs example" >
            <Tab icon={<EventAvailableIcon />} label="Passed Events" iconPosition='start' {...indexProps(0)} />
            <Tab icon={<UpcomingIcon />} label="Upcoming Events" iconPosition='start' {...indexProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <PastList setFlag={setFlag} updateRecord={getUpdateRecordValue} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <UpcomingList setFlag={setFlag} updateRecord={getUpdateRecordValue} />
        </CustomTabPanel>
      </Box>
    </>
  );
}

const UpcomingList = ({ setFlag, updateRecord }) => {
  const [upcomingEventList, setUpcomingEventList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(() =>
    [

      {
        accessorKey: "eventName",
        header: "Event Name",
        size: 250
      },
      {
        accessorKey: "eventStartDate",
        header: "Start Date",
        size: 150
      },
      {
        accessorKey: "eventEndDate",
        header: "End Date",
        size: 150
      },
      {
        accessorKey: "eventVenue",
        header: "Event Venue",
        size: 150
      },
      {
        accessorKey: "countryName",
        header: "Country",
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
            <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
            </Tooltip>
            {/* <EditIcon onClick={()=>{editRecord(row.original)}} color='primary'/> */}
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);

  useEffect(() => {
    getUpcomingEventList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //Prepare request body to get Event list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;

    return requestBody;
  }

  const getUpcomingEventList = async () => {
    const requestBody = prepareRequest()
    const res = await EventsService.getUpcomingEventList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setUpcomingEventList(res);
    }
  }


  //Open Form To edit Record
  const editRecord = (record: EventsModel) => {
    // screenOptionButtons(record);
    updateRecord(record);
    setFlag(true)
  };


  const onSubmit = () => {
    getUpcomingEventList();
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={onSubmit}
      >
        {
          formik =>
          (
            <Form>
                {upcomingEventList ? (
              <CustomTableGrid
                item={
                  <FormikControl
                    control='materialTable'
                    tableColumn={columns}
                    tableData={upcomingEventList}
                    setPagination={setPagination}
             
                  />
                }
              />
            ) : null}
            </Form>
          )
        }
      </Formik>
    </>
  )
}

const PastList = ({ setFlag, updateRecord }) => {
  const [pastEventList, setPastEventList] = useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });
  const [onSaved, setOnSaved] = useState(false);
  const [onClose, setOnClose] = useState(false);

  useEffect(()=>{
    setOnClose(onSaved)
  },[onSaved])
  
  const columns = useMemo(() =>
    [
      {
        accessorKey: "eventName",
        header: "Event Name",
        size: 250
      },
      {
        accessorKey: "eventStartDate",
        header: "Start Date",
        size: 150
      },
      {
        accessorKey: "eventEndDate",
        header: "End Date",
        size: 150
      },
      {
        accessorKey: "eventVenue",
        header: "Event Venue",
        size: 150
      },
      {
        accessorKey: "countryName",
        header: "Country",
        size: 90
      },
      {
        header: 'Add Gallary',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex align-items-center event-list-section '>
            {/* <CollectionsIcon onClick={() => { addGallaryImage(row.original) }} color='primary' /> */}
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
            </Tooltip>
            <DialogBox
                title="Add Event Images"
                buttonTitle={<CollectionsIcon color='primary' />}
                element={<EventGallery  event={row.original} setOnSaved={setOnSaved} setOnClose={setOnClose} />}
                setOnClose={setOnClose} />
          </div>
        ),
        size: 150,
        grow: false,
      },
    ], []);

  useEffect(() => {
    getPastEventList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //Prepare request body to get Events list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }

  const getPastEventList = async () => {
    const requestBody = prepareRequest();
    const res = await EventsService.getPastEventList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setPastEventList(res);
    }
  }


  const deleteRecord = async (record: EventsModel) => {
    const requestData: EventsModel = new EventsModel();
    requestData.eventId = record.eventId

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    // const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR);
    if (deleteFlag) {
      const res = await EventsService.deletePastEventList(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getPastEventList();
        // loadRecentBlog();
      }
    }
  }



  const onSubmit = () => {
    getPastEventList();
  };

  return (
    <>

      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={onSubmit}
      >
        {
          formik =>
          (
            <Form>
                   {pastEventList ? (
              <CustomTableGrid
                item={
                  <FormikControl
                    control='materialTable'
                    tableColumn={columns}
                    tableData={pastEventList}
                    setPagination={setPagination}

                  />
                }
              />
            ) : null}
            </Form>
          )
        }
      </Formik>
    </>
  )
}
